import { Popconfirm } from 'antd';
import i18next from 'i18next';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import Cannot from '~/components/Cannot';
import Strong from '~/components/Strong';
import { TableActions } from '~/components/Table';

export const operationalsColumns = (handleEdit, handleDelete, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:Nome')}:</Strong> {record?.name}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Can permission="@operationals/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Cannot permission="@operationals/edit">
                <Button style={{ margin: 'auto' }} size="small" title="Visualizar" onClick={() => handleEdit(record)}>
                  <FaEye />
                </Button>
              </Cannot>
              <Can permission="@operationals/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:Nome'),
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Can permission="@operationals/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Cannot permission="@operationals/edit">
            <Button style={{ margin: 'auto' }} size="small" title="Visualizar" onClick={() => handleEdit(record)}>
              <FaEye />
            </Button>
          </Cannot>
          <Can permission="@operationals/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};
